import { ListPageSkeleton } from '@/components/PageSkeleton';
import { Skeleton } from '@/components/ui/skeleton';
import { AccountApplicationStatistics } from './components/AccountApplicationStatistics';

/** 开户记录代码加载时的占位，沿用无额外外层内边距和初始无分页的布局 */
export function AccountApplicationRecordsSkeleton() {
  return (
    <div className="flex flex-col gap-4" aria-hidden="true">
      {/** 保留四张统计卡片的位置，避免页面代码加载后列表下移 */}
      <AccountApplicationStatistics loading />
      <ListPageSkeleton
        columnCount={10}
        showPagination={false}
        contentClassName="gap-4 p-6"
        filterArea={
          <div className="flex flex-col gap-2 pb-4">
            {/** 日期和编号位于主筛选行，多条件筛选条独占下一行 */}
            <div className="flex flex-wrap items-center gap-2">
              <Skeleton className="h-9 w-65" />
              <Skeleton className="h-9 w-45" />
              <div className="ml-auto flex items-center gap-2">
                <Skeleton className="h-9 w-20" />
                <Skeleton className="h-9 w-20" />
                <Skeleton className="h-9 w-24" />
              </div>
            </div>
            <Skeleton className="h-9 w-full" />
          </div>
        }
      />
    </div>
  );
}
